import { TOUCH_TARGET_MIN_SIZE_PX } from 'Utils/touchTarget';

// The Skip Tutorial link is one 19px line of text. On a touch screen it is a 44px tall target that
// looks the same: the extra is padding, given back with negative margins so the header does not move.
export const SKIP_TUTORIAL_LINE_PX = 19;
const SKIP_TUTORIAL_TOUCH_PADDING_PX = (TOUCH_TARGET_MIN_SIZE_PX - SKIP_TUTORIAL_LINE_PX) / 2;
export const skipTutorialTouchSx = {
  '@media (pointer: coarse)': {
    paddingBlock: `${SKIP_TUTORIAL_TOUCH_PADDING_PX}px`,
    marginBlock: `-${SKIP_TUTORIAL_TOUCH_PADDING_PX}px`,
  },
} as const;
